import React from 'react';
import {FormikErrors, withFormik} from 'formik';
import PropTypes from 'prop-types';
import {LegalRepresentativeServiceRequest} from 'commons/models';
import {InferPropTypes} from 'commons/types/Types';
import {FieldShape} from 'commons/shapes';
import {formValidator} from 'commons/utils/Functions';
import InnerFormShareholderLegalRepresentative from './InnerFormShareholderLegalRepresentative';
import {Messages} from 'commons/constants';

ShareholderLegalRepresentativeForm.propTypes = {
    viewId: PropTypes.number.isRequired,
    fieldHandler: PropTypes.func.isRequired,
    submitHandler: PropTypes.func.isRequired,
    fields: PropTypes.arrayOf(PropTypes.shape(FieldShape).isRequired).isRequired,
    auxLegalRepresentative: PropTypes.any,
};

const FormControl = withFormik<
    InferPropTypes<typeof ShareholderLegalRepresentativeForm.propTypes>,
    LegalRepresentativeServiceRequest
>({
    mapPropsToErrors: () => {
        return {
            expedientId: '',
            workflowId: '',
            viewId: '',
            viewFatherId: '',
            kycId: '',
            personTypeKey: '',
            rfc: '',
            name: '',
            lastName: '',
            secondLastName: '',
            birthDate: '',
            rol: '',
            fatherKycId: '',
            curp: '',
            nif: '',
            foreignCitizen: '',
        };
    },
    mapPropsToValues: (props) => {
        const {auxLegalRepresentative} = props;
        if (auxLegalRepresentative) {
            return {
                expedientId: auxLegalRepresentative.expedientId || 0,
                workflowId: auxLegalRepresentative.workflowId || 0,
                viewId: auxLegalRepresentative.viewId || 0,
                viewFatherId: auxLegalRepresentative.viewFatherId || 0,
                kycId: auxLegalRepresentative.kycId || 0,
                personTypeKey: auxLegalRepresentative.personTypeKey || '',
                rfc: auxLegalRepresentative.rfc || '',
                name: auxLegalRepresentative.name || '',
                lastName: auxLegalRepresentative.lastName || '',
                secondLastName: auxLegalRepresentative.secondLastName || '',
                birthDate: auxLegalRepresentative.birthDate || null,
                rol: auxLegalRepresentative.rol || '',
                fatherKycId: auxLegalRepresentative.fatherKycId || 0,
                curp: auxLegalRepresentative.curp || '',
                nif: auxLegalRepresentative.nif || '',
                foreignCitizen: auxLegalRepresentative.foreignCitizen || false,
                validationResult: !auxLegalRepresentative.foreignCitizen,
            };
        } else {
            return {
                expedientId: 0,
                workflowId: 0,
                viewId: 0,
                viewFatherId: 0,
                kycId: 0,
                personTypeKey: '',
                rfc: '',
                name: '',
                lastName: '',
                secondLastName: '',
                birthDate: null,
                rol: '',
                fatherKycId: 0,
                curp: '',
                nif: '',
                foreignCitizen: false,
                validationResult: false,
            };
        }
    },
    validateOnBlur: true,
    validateOnChange: true,
    validate: (values: LegalRepresentativeServiceRequest, props) => {
        const errors: FormikErrors<LegalRepresentativeServiceRequest> = {};
        formValidator(props.fields, errors, values);
        if (!values.foreignCitizen) {
            if (values.curp && !values.validationResult) {
                errors.curp = Messages.CURP_VALIDATION_REQUIRED;
            }
        }
        return errors;
    },
    handleSubmit: (values, actions) => {
        actions.setSubmitting(false);
        actions.props.submitHandler({...values});
    },
})(InnerFormShareholderLegalRepresentative);

function ShareholderLegalRepresentativeForm(
    props: InferPropTypes<typeof ShareholderLegalRepresentativeForm.propTypes>
) {
    const {submitHandler, fields, auxLegalRepresentative, viewId, fieldHandler} = props;

    /* eslint-disable react/jsx-handler-names */
    return (
        <FormControl
            viewId={viewId}
            fieldHandler={fieldHandler}
            fields={fields}
            submitHandler={submitHandler}
            auxLegalRepresentative={auxLegalRepresentative}
        />
    );
}

export default ShareholderLegalRepresentativeForm;
